import * as Q from "q";
import * as SDK_Shim from "VSS/SDK/Shim";
import URI = require("Presentation/Scripts/URI");
import * as VC_SpecUtils from "VersionControl/Scripts/VersionSpecUtils";
import { VersionSpec } from "VersionControl/Scripts/TFS.VersionControl.VersionSpecs";
import { IResourceService, IResourceVersion, VersionControlType } from "BuiltInExtensions/Scripts/TFS.Extensions.CodeEditor.Contributions";

export class ResourceService implements IResourceService {
    public getResourceUriFromResourceVersion(version: IResourceVersion): IPromise<string> {
        return Q(this.createResourceUriFromResourceVersion(version));
    }

    public getResourceVersion(uri: string): IPromise<IResourceVersion> {
        return Q(this._getResourceVersion(uri));
    }

    public getResourceUri(repositoryId: string, version: string, path: string, versionControlType?: VersionControlType) {
        return Q(this._createResourceUri(repositoryId, version, path, versionControlType));
    }

    private _createResourceUri(repositoryId: string, version: string, path: string, versionControlType?: VersionControlType) {
        path = path || "";
        // Remove first '/' and URI encode path
        path = path.indexOf('/') === 0 ? path.substring(1) : path;
        versionControlType = versionControlType || (repositoryId ? "git" : "tfvc");
        repositoryId = repositoryId || "";
        version = URI.encode(version);
        path = path.split("/")
                .map(URI.encode)
                .join("/");
        return `inmemory://model/${versionControlType}/${repositoryId}/${version}/${path}`
    }

    private createResourceUriFromResourceVersion(version: IResourceVersion): string {
        var repositoryId = "";
        var versionSpec: VersionSpec;
        if (version.versionControlType === "git") {
            repositoryId = version.repositoryId;
            versionSpec = VC_SpecUtils.gitVersionDescriptorToVersionSpec(version.version);
        }
        else {
            versionSpec = VC_SpecUtils.tfvcVersionDescriptorToVersionSpec(version.version)
        }
        return this._createResourceUri(repositoryId, versionSpec.toVersionString(), version.path, version.versionControlType);
    }

    private _getResourceVersion(uri: string): IResourceVersion {
        const resourceUriRegex = /^inmemory:\/\/model\/([^/]*)\/([^/]*)\/([^/]*)\/(.*)/;
        const matches = uri.match(resourceUriRegex);
        if (matches) {
            const versionControlType = matches[1];
            const repositoryId = matches[2];
            const versionString = URI.decode(matches[3]);
            let path = matches[4].split("/")
                .map(URI.decode)
                .join("/");
            path = path[0] === '/' ? path : "/" + path;
            if (versionControlType === "git") {
                const version = VC_SpecUtils.gitVersionStringToVersionDescriptor(versionString);
                return {
                    versionControlType,
                    path,
                    repositoryId,
                    version
                };
            }
            else if (versionControlType === "tfvc") {
                const version = VC_SpecUtils.tfvcVersionStringToVersionDescriptor(versionString);
                return {
                    versionControlType,
                    path,
                    version
                };
            }
        }
        return null;
    }
}

// Make it possible for extensions to retrieve ResourceService via VSS.getService('ms.vss-code-web.code-editor-resource-service')
SDK_Shim.VSS.register('ms.vss-code-web.code-editor-resource-service', () => {
    return new ResourceService();
});